import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _085660e2 = () => interopDefault(import('../../../pages/collections/index.vue' /* webpackChunkName: "pages/collections/index" */))
const _6533320c = () => interopDefault(import('../../../pages/multi-model.vue' /* webpackChunkName: "pages/multi-model" */))
const _97493520 = () => interopDefault(import('../../../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _b3c6eefe = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _91731444 = () => interopDefault(import('../../../pages/wishlist.vue' /* webpackChunkName: "pages/wishlist" */))
const _0eea4807 = () => interopDefault(import('../../../pages/pages/reviews.vue' /* webpackChunkName: "pages/pages/reviews" */))
const _47aba937 = () => interopDefault(import('../../../pages/pages/rewards-subscribe-to-sms.vue' /* webpackChunkName: "pages/pages/rewards-subscribe-to-sms" */))
const _f6f0726a = () => interopDefault(import('../../../pages/pages/share.vue' /* webpackChunkName: "pages/pages/share" */))
const _6805cd16 = () => interopDefault(import('../../../pages/pages/store-locator.vue' /* webpackChunkName: "pages/pages/store-locator" */))
const _147ce62e = () => interopDefault(import('../../../pages/pages/subscribe-to-sms.vue' /* webpackChunkName: "pages/pages/subscribe-to-sms" */))
const _4b46a945 = () => interopDefault(import('../../../pages/blogs/_blogHandle/index.vue' /* webpackChunkName: "pages/blogs/_blogHandle/index" */))
const _2f1d3afc = () => interopDefault(import('../../../pages/collections/_collectionHandle.vue' /* webpackChunkName: "pages/collections/_collectionHandle" */))
const _706670f8 = () => interopDefault(import('../../../pages/lp/_pageHandle.vue' /* webpackChunkName: "pages/lp/_pageHandle" */))
const _56e120bc = () => interopDefault(import('../../../pages/pages/_pageHandle.vue' /* webpackChunkName: "pages/pages/_pageHandle" */))
const _09f0e4fa = () => interopDefault(import('../../../pages/products/_productHandle.vue' /* webpackChunkName: "pages/products/_productHandle" */))
const _4099235c = () => interopDefault(import('../../../pages/blogs/_blogHandle/_articleHandle.vue' /* webpackChunkName: "pages/blogs/_blogHandle/_articleHandle" */))
const _e796dbee = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/collections",
    component: _085660e2,
    name: "collections"
  }, {
    path: "/multi-model",
    component: _6533320c,
    name: "multi-model"
  }, {
    path: "/privacy-policy",
    component: _97493520,
    name: "privacy-policy"
  }, {
    path: "/search",
    component: _b3c6eefe,
    name: "search"
  }, {
    path: "/wishlist",
    component: _91731444,
    name: "wishlist"
  }, {
    path: "/pages/reviews",
    component: _0eea4807,
    name: "pages-reviews"
  }, {
    path: "/pages/rewards-subscribe-to-sms",
    component: _47aba937,
    name: "pages-rewards-subscribe-to-sms"
  }, {
    path: "/pages/share",
    component: _f6f0726a,
    name: "pages-share"
  }, {
    path: "/pages/store-locator",
    component: _6805cd16,
    name: "pages-store-locator"
  }, {
    path: "/pages/subscribe-to-sms",
    component: _147ce62e,
    name: "pages-subscribe-to-sms"
  }, {
    path: "/blogs/:blogHandle",
    component: _4b46a945,
    name: "blogs-blogHandle"
  }, {
    path: "/collections/:collectionHandle",
    component: _2f1d3afc,
    name: "collections-collectionHandle"
  }, {
    path: "/lp/:pageHandle?",
    component: _706670f8,
    name: "lp-pageHandle"
  }, {
    path: "/pages/:pageHandle?",
    component: _56e120bc,
    name: "pages-pageHandle"
  }, {
    path: "/products/:productHandle?",
    component: _09f0e4fa,
    name: "products-productHandle"
  }, {
    path: "/blogs/:blogHandle?/:articleHandle",
    component: _4099235c,
    name: "blogs-blogHandle-articleHandle"
  }, {
    path: "/",
    component: _e796dbee,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
